/**
 * Spanish message for errors from the roles screens. The RBAC functions already raise Spanish
 * messages; raw PostgREST / constraint errors are translated here.
 */
const RAW: [RegExp, string][] = [
  [/user_roles_role_id_fkey|violates foreign key constraint/i, 'No se puede eliminar: el rol está asignado a usuarios. Quita las asignaciones primero.'],
  [/row-level security|permission denied|No autorizado/i, 'No tienes permiso para esta acción.'],
  [/Failed to fetch|NetworkError/i, 'Sin conexión con el servidor. Intenta de nuevo.'],
];

export function rolesErrorMessage(err: unknown): string {
  const message = err instanceof Error ? err.message.split('|')[0] : String(err);
  const raw = RAW.find(([re]) => re.test(message));
  if (raw) return raw[1];
  return message || 'Ocurrió un error inesperado.';
}
